import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {NetworkLayersService} from '../network-layers/network-layers.service';
import {DiagramMappersUtilsService} from '../diagram-mappers-utils/diagram-mappers-utils.service';
import {MetaDataService} from '../../../../services/metaData/meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class MapSummaryStatisticsService {

  constructor(private networkLayersService: NetworkLayersService,
              private metaDataService: MetaDataService,
              private diagramMappersUtilsService: DiagramMappersUtilsService) {
  }

  calculateNodesStatusDistribution(nodes) {
    const statusObject = {normal: 0, fault: 0, locked: 0};
    for (const node of nodes) {
      if (_.isEqual(node.operState.state, 15)) {
        statusObject.normal++;
      } else {
        statusObject.fault++;
      }

      if (node.adminState === 'LOCKED') {
        statusObject.locked++;
      }
    }
    return statusObject;
  }

  calculatePeerConnectionsStatusDistribution(peerConnections) {
    return this.calculateConnectionsAndPConsDistribution(peerConnections, 'peerConnection');
  }

  calculateConnectionsStatusDistribution(connections) {
    return this.calculateConnectionsAndPConsDistribution(connections, 'connection');
  }

  constructDataForCharts(statistics) {
    if (statistics.length === 0) {
      return [];
    }
    const result = [];
    let previousStartTime;
    let intervalStatistic: any = {};
    intervalStatistic = this.initialiseStatisticsInterval(statistics[0], intervalStatistic);
    intervalStatistic.timeInterval = statistics[0].startTime;
    previousStartTime = statistics[0].startTime;
    result.push(intervalStatistic);
    for (let i = 1; i < statistics.length; i++) {
      if (statistics[i].startTime !== previousStartTime) {
        intervalStatistic = {};
        intervalStatistic.timeInterval = statistics[i].startTime;
        previousStartTime = statistics[i].startTime;
        intervalStatistic = this.initialiseStatisticsInterval(statistics[i], intervalStatistic);
        result.push(intervalStatistic);
      } else {
        intervalStatistic = this.updateStatisticsInterval(statistics[i], intervalStatistic);
      }
    }
    for (const r of result) {
      r.timeInterval = this.getDateInCorrectFormat(r.timeInterval);
    }
    return result;
  }

  private calculateConnectionsAndPConsDistribution(items, connectionType) {
    const selectedLayers = this.networkLayersService.getSelectedLayers();
    const statusObject = {normal: 0, fault: 0, locked: 0};

    for (const item of items) {
      this.isAtLeastOneLayerHaveIssues(selectedLayers, item, connectionType) ?
        statusObject.fault++ : statusObject.normal++;

      if (_.isEqual(connectionType, 'peerConnection') && item.adminState
        && item.adminState.startsWith('LOCKED')) {
        statusObject.locked++;
      }
    }

    return statusObject;
  }

  private doesConnectionOrPConHaveIssues(item, layerName, connectionType) {
    if (connectionType === 'connection') {
      return !_.isEqual(this.diagramMappersUtilsService.connectionStatusByLayer(item, layerName), 'GOOD');
    } else {
      return !_.isEqual(this.diagramMappersUtilsService.peerConnectionStatusByLayer(item, layerName), 'GOOD');
    }
  }

  private initialiseStatisticsInterval(firstInterval, intervalStatistic) {
    if (firstInterval.statistics.hasOwnProperty('failedRoutingAttempts')) {
      intervalStatistic.failedRoutingAttempts = firstInterval.statistics.failedRoutingAttempts;
      intervalStatistic.alternativeRoutingAttempts = firstInterval.statistics.alternativeRoutingAttempts;
      intervalStatistic.routingAttempts = firstInterval.statistics.routingAttempts;
      intervalStatistic.discardRoutingAttempts = firstInterval.statistics.discardRoutingAttempts;
      intervalStatistic.destinationCall = firstInterval.statistics.destinationCall;
      intervalStatistic.transientCall = firstInterval.statistics.transientCall;
    } else {
      intervalStatistic.transientCall = firstInterval.statistics.transientCall;
    }

    return intervalStatistic;
  }

  private updateStatisticsInterval(intervalToUpdateFrom, intervalStatisticToUpdate) {
    if (intervalToUpdateFrom.statistics.hasOwnProperty('routingAttempts')) {
      intervalStatisticToUpdate.routingAttempts += intervalToUpdateFrom.statistics.routingAttempts;
      intervalStatisticToUpdate.failedRoutingAttempts += intervalToUpdateFrom.statistics.failedRoutingAttempts;
      intervalStatisticToUpdate.alternativeRoutingAttempts += intervalToUpdateFrom.statistics.alternativeRoutingAttempts;
      intervalStatisticToUpdate.discardRoutingAttempts += intervalToUpdateFrom.statistics.discardRoutingAttempts;
      intervalStatisticToUpdate.destinationCall += intervalToUpdateFrom.statistics.destinationCall;
      intervalStatisticToUpdate.transientCall += intervalToUpdateFrom.statistics.transientCall;
    } else {
      intervalStatisticToUpdate.transientCall += intervalToUpdateFrom.statistics.transientCall;
    }

    return intervalStatisticToUpdate;
  }

  private getDateInCorrectFormat(timeInterval) {
    const date = new Date(timeInterval * 1000);
    const hour = date.getHours().toString();
    let minute = date.getMinutes().toString();
    if (minute.length === 1) {
      minute = '0' + minute;
    }
    return hour + ':' + minute;
  }

  private isAtLeastOneLayerHaveIssues(selectedLayers, item, connectionType): boolean {
    return (selectedLayers.topology && this.doesConnectionOrPConHaveIssues(item, 'topology', connectionType)) ||
      (selectedLayers.quality && this.doesConnectionOrPConHaveIssues(item, 'quality', connectionType));
  }
}
